<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="mb-3 total_figures flex align-items-stretch">
          <div>
            <p><strong>{{ totalData.websites }}</strong> - линков на проверку</p>
            <p><strong>{{ totalData.checks }}</strong> - просканировано</p>
            <p><strong @click="updateFilter(3)" class="badge badge-primary pointer">{{ totalData.pass }}</strong> -
              прошли проверку</p>
            <p><strong @click="updateFilter(4)" class="badge badge-primary pointer">{{ totalData.errors }}</strong> -
              ошибок при проверке</p>
            <p><strong @click="updateFilter(5)" class="badge badge-danger pointer">{{ totalData.blocked }}</strong> -
              ограничения РКН</p>
          </div>
          <div class="ml-3">
            <p>проверка: <strong>{{ getDateOfCheck() }}</strong></p>
            <div v-if="filter && filter.active">
              <span v-for="(usedFilter, i) in filter.usedFilters" class="badge badge-info">{{ usedFilter }}</span>
              <button @click="updateFilter(0)" class="btn btn-default">сбросить фильтр</button>
            </div>
          </div>
          <div class="ml-3 text-right" style="flex:1">
            <div class="form-group flex">
              <select v-model="newRecord.project_id" class="form-control">
                <option v-for="project in projects" :value="project.id">{{ project.title }}</option>
              </select>
              <select v-model="newRecord.type" class="form-control">
                <option v-for="(type, id) in types" :value="id">{{ type }}</option>
              </select>
            </div>
            <input type="text" v-model="newRecord.url" placeholder="Новый url для проверки без http!"
                   class="form-control">
            <button @click="saveNewRecord" class="btn btn-success mt-1">Сохранить новый</button>
          </div>
        </div>
        <div>
          <button @click="getRecords" class="btn btn-outline-info">Обновить список</button>
        </div>
        <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>
        <table v-if="totalData.websites" class="table table-sm table-hover mt-0">
          <thead>
          <tr>
            <th>URL страницы</th>
            <th>Тип</th>
            <th></th>
            <th>Информация</th>
            <!--            <th>Ошибка</th>-->
            <th>Не информировать</th>
            <th></th>
          </tr>
          </thead>
          <tbody v-if="filter && filter.active">
          <template v-for="(domain, i) in filter.websites">
            <TableTrCheckUrl
              :domain="domain"
              :check="checks[domain.id]"
              :updateRecord="(action, r) => updateRecord(action, r)"
              :types="types"
              :key="i"/>
          </template>
          </tbody>
          <tbody v-if="!filter">
          <tr>
            <td colspan="20"><strong>SEO домены</strong></td>
          </tr>
          <template v-for="(domain, index) in getSeoDomains()">
            <TableTrCheckUrl
              :domain="domain"
              :check="checks[domain.id]"
              :updateRecord="(action, r) => updateRecord(action, r)"
              :types="types"
              :key="index"/>
          </template>
          <template v-for="(project, index) in projects" v-if="project.web_sites && project.web_sites.length">
            <template v-for="(webSite, i) in getWebSitesByType(project.web_sites)">
              <tr v-if="i === 0">
                <td>
                  <div class="flex justify-content-between">
                    <strong>{{ project.title }}</strong>
                  </div>
                </td>
                <td colspan="20"></td>
              </tr>
              <TableTrCheckUrl
                :domain="webSite"
                :check="checks[webSite.id]"
                :updateRecord="(action, r) => updateRecord(action, r)"
                :types="types"/>
            </template>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import TableTrCheckUrl from '@/views/projects/components/TableTrCheckUrl'
import moment from 'moment'

export default {
  components: { TableTrCheckUrl },
  data () {
    return {
      filter: null,
      types: {
        1: 'SEO',
        2: 'Расходный'
      },
      loading: false,
      loadingColor: this.$constants.LOADING_COLOR,
      projects: [],
      newRecord: {
        project_id: 1,
        type: 1
      },
      checks: {},
      totalData: {}
    }
  },
  mounted () {
    this.getRecords()
  },
  methods: {
    getDateOfCheck () {
      if (!this.checks || !this.checks[Object.keys(this.checks)[0]]) return
      return moment(this.checks[Object.keys(this.checks)[0]].created_at).format('DD.MM.YYYY HH:mm')
    },
    getSeoDomains () {
      return Object.keys(this.projects).reduce((acc, p) => {
        acc = [...acc, ...this.projects[p].web_sites.filter((w) => +w.type === 1)]
        return acc
      }, [])
    },
    getWebSitesByType (records) {
      return records.filter((r) => +r.type === 2)
      let arr = []
      Object.keys(this.types).forEach((t) => {
        arr = [...arr, ...records.filter((r) => +r.type === +t)]
      })
      return arr
    },
    async saveNewRecord () {
      if (!this.newRecord.url) return
      const record = await this.updateRecord('new', this.newRecord)
      if (!record) return
      const index = this.projects.findIndex((p) => p.id === record.project_id)
      this.projects[index].web_sites.push(record)
      this.newRecord = {
        project_id: 1,
        type: 1
      }
    },
    // async deleteRecord(id, index) {
    //   const record = await this.updateRecord('delete', {id: id});
    //   // if (!record) return;
    //   console.log('deleted', id);
    //   this.projects[index].web_sites = this.projects[index].web_sites.filter((r) => r.id !== +id);
    // },
    async updateRecord (action, record) {
      if (this.loading) return
      this.loading = true
      const { data } = await api.post('/projects/websites', {
        action,
        record
      })
      if (data.success) {
        toastr['success'](data.message || 'Сохранено')
        if (action === 'delete') {
          const index = this.projects.findIndex((p) => p.id === +record.project_id)
          this.projects[index].web_sites = this.projects[index].web_sites.filter((r) => r.id !== +record.id)
        }
        this.loading = false
        return data.record || true
      } else {
        toastr['warning'](data.message || 'Ошибка')
      }
      this.loading = false
    },
    addNewRecord (index) {
      if (this.newRecord[index]) return
      this.newRecord[index] = {
        project_id: this.projects[index].id,
        url: null,
        type: Object.keys(this.types)[0]
      }
      this.newRecord = { ...this.newRecord }
    },
    async getRecords () {
      this.loading = true
      const { data } = await api.index('/projects/blockList')
      if (data.success) {
        this.checks = data.checks.reduce((acc, c) => {
          acc[c.website_id] = c
          return acc
        }, {})
        this.projects = data.projects
        this.updateTotalData()
      } else {
        toastr['warning'](data.message || 'Ошибка')
      }
      this.loading = false
    },
    updateTotalData () {
      const totalWebSites = this.projects.reduce((acc, p) => {
        acc += p.web_sites.length
        return acc
      }, 0)
      const totalChecks = Object.keys(this.checks).length
      const totalPassChecks = Object.values(this.checks).filter((c) => c.is_check_success).length
      const blocked = Object.values(this.checks).filter((c) => c.is_blocked).length
      this.totalData = {
        websites: totalWebSites,
        checks: totalChecks,
        pass: totalPassChecks,
        errors: totalChecks - totalPassChecks,
        blocked: blocked,
      }
    },
    updateFilter (type) {
      let records = []
      this.filter = { usedFilters: [], websites: [] }
      switch (type) {
        case 0:
          this.filter = null
          return
          break
        case 3:
          this.filter.usedFilters.push('прошли проверку')
          records = Object.values(this.checks).filter((c) => c.is_check_success).reduce((acc, c) => {
            acc.push(c.website_id)
            return acc
          }, [])
          break
        case 4:
          this.filter.usedFilters.push('ошибки при проверке')
          records = Object.values(this.checks).filter((c) => !c.is_check_success).reduce((acc, c) => {
            acc.push(c.website_id)
            return acc
          }, [])
          break
        case 5:
          this.filter.usedFilters.push('ограничения')
          records = Object.values(this.checks).filter((c) => c.is_check_success && c.is_blocked).reduce((acc, c) => {
            acc.push(c.website_id)
            return acc
          }, [])
          break
      }
      this.filter.websites = this.projects.reduce((acc, p) => {
        acc = [...acc, ...p.web_sites.filter((w) => records.includes(w.id))]
        return acc
      }, [])
      this.filter.active = true
    }
  }
}

</script>

<style scoped>
.total_figures p {
  margin-bottom: 1px;
}

.btn i {
  text-align: center
}

.btn {
  padding: 1px 5px !important;
}
</style>
